import { render } from "./candidateList.vue?vue&type=template&id=72292912&ts=true"
import script from "./candidateList.vue?vue&type=script&lang=ts"
export * from "./candidateList.vue?vue&type=script&lang=ts"

import "./candidateList.vue?vue&type=style&index=0&id=72292912&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__